import { Box, styled } from "@mui/material";

export const StyledNavbar = styled(Box)(({ theme }) => ({
  height: "5rem",
  width: "100%",
  position: "relative",
  ".desktop": {
    display: "flex",
  },
  ".mobile": {
    display: "none",
  },
  ".logoWrapper": {
    position: "absolute",
    left: "1rem",
    height: "100%",
    img: {
      width: "100%",
      height: "100%",
    },
  },
  ".navlinks": {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    gap: "3rem",
    color: theme.color.main,
    h6: {
      padding: ".25rem",
      cursor: "pointer",
      "&:hover": {
        borderBottom: `4px solid ${theme.color.contrastColor}`,
        transition: ".1s",
      },
    },
  },
  [`@media screen and (max-width: ${theme.breakpoints.values.tablet}px)`]: {
    width: "100%",
    zIndex: "99",
    ".desktop": {
      display: "none",
    },
    ".mobile": {
      display: "flex",
    },
    ".menuIcon": {
      position: "absolute",
      right: "1rem",
      top: "1rem",
      color: theme.color.main,
    },
    ".logoWrapper": {
      height: "80%",
      left: ".5rem",
      top: ".5rem",
    },
    ".navlinks": {
      display:"none"
    },
    ".navLinksExtended": {
      display: "flex",
      flexDirection:"column",
      gap: "1rem",
      justifyContent: "start",
      paddingBlock: "10rem",
      background: theme.color.background,
      height: "fit-content",
    },
  },
}));
